import {extractDataFromResponse} from "../../../saga-utils/httpInterceptorWrapper";
import {
    LOAD_NACHRICHTEN_LIST_DATA,
    loadNachrichtenListDataFailureAction,
    loadNachrichtenListDataSuccessAction
} from "../../listActions";
import {emitNotificationAction} from "../../../notification/notificationAction";
import {createErrorNotification} from "../../../../models/notification";
import i18next from "i18next";
import {call, put, takeLatest} from "redux-saga/effects"
import {i18_LIST} from "../../../../i18nReferences";
import {getNachrichtListData} from "../../../../api/nachrichtApi";
import { standardizeListParametersOfParameterObject } from "../../../utils/urlHelper";

function* processLoadNachrichtenListData({payload}) {
    try {
        const standardNachrichtenListParameter = standardizeListParametersOfParameterObject(payload.nachrichtenListParameter)
        const nachrichten = extractDataFromResponse(yield call(getNachrichtListData, {nachrichtenListParameter: standardNachrichtenListParameter}))
        yield put(loadNachrichtenListDataSuccessAction(nachrichten))
    } catch (err) {
        yield put(emitNotificationAction(createErrorNotification(i18next.t('LIST_NACHRICHTEN.LOAD_NACHRICHTEN_LIST_DATA_FAILED_INFO', {ns: i18_LIST}), 'loadListData')))
        yield put(loadNachrichtenListDataFailureAction())
        console.log(err)
    }
}

export function* watchLoadNachrichtenListData() {
    yield takeLatest(LOAD_NACHRICHTEN_LIST_DATA, processLoadNachrichtenListData)
}